// components/newabout/about-hero.tsx
import { useLanguage } from '../../context/LanguageContext';
import { Link } from 'react-router-dom';

export function AboutHero({ hero, stats }) {
  const { translate } = useLanguage();

  // Title splitting logic
  const titleValue = hero?.title?.value || translate('newAbout.hero.title1') + ' ' + translate('newAbout.hero.title2') || 'The Future of Vehicle Auctions';
  const words = titleValue.split(" ");
  const firstPart = words.length > 2 ? words.slice(0, -2).join(" ") : '';
  const lastTwoWords = words.length > 1 ? words.slice(-2).join(" ") : titleValue;

  // Fallback stats if none provided
  const fallbackStats = [
    {
      number: { value: '40k+' },
      title: { value: translate('newAbout.hero.stat1') || 'SUCCESSFUL AUCTIONS' }
    },
    {
      number: { value: '110+' },
      title: { value: translate('newAbout.hero.stat2') || 'COUNTRIES SERVED' }
    },
    {
      number: { value: '700+' },
      title: { value: translate('newAbout.hero.stat3') || 'PARTNERS' }
    }
  ];

  const displayStats = stats.length > 0 ? stats : fallbackStats;

  return (
    <section
      className="relative pt-20 sm:pt-28 lg:pt-40"
      style={{ background: 'linear-gradient(180deg, #000000 0%, #374047 100%)' }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h1 className="text-5xl text-white sm:text-6xl lg:text-[72px] font-black leading-[1.1] mb-8 tracking-tight">
          {firstPart && <>{firstPart}<br /></>}
          <span className="text-blue-500">{lastTwoWords}</span>
        </h1>

        {/* Render rich text subtitle */}
        <div
          className="text-gray-400 text-base sm:text-lg leading-relaxed max-w-2xl mx-auto mb-12 font-medium prose prose-invert"
          dangerouslySetInnerHTML={{
            __html: hero?.subtitle?.value || translate('newAbout.hero.subtitle') || ''
          }}
        />

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-24 sm:mb-32">
          <Link
            to={hero?.primary_btn_link?.value || "/auctions"}
            className="w-full sm:w-auto bg-[#1d63a3] hover:bg-blue-700 text-white px-10 py-4 rounded-xl font-bold text-sm transition-all shadow-lg shadow-blue-900/20 inline-block text-center"
          >
            {hero?.primary_btn_text?.value || translate('newAbout.hero.exploreAuctions') || 'Explore Auctions'}
          </Link>

          <Link
            to={hero?.secondary_btn_link?.value || "#"}
            className="w-full sm:w-auto border-2 border-gray-500/50 hover:border-white text-white px-10 py-4 rounded-xl font-bold text-sm transition-all hover:bg-white/5 inline-block text-center"
          >
            {hero?.secondary_btn_text?.value || translate('newAbout.hero.joinNetwork') || 'Join the Network'}
          </Link>
        </div>
      </div>

      <div className="bg-primary py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-4 items-center">
            {displayStats.slice(0, 3).map((stat, index) => (
              <div
                key={index}
                className={`flex flex-col items-center text-center ${
                  index < 2 && displayStats.length > index + 1 ? 'md:border-r border-white/20' : ''
                }`}
              >
                <span className="text-white text-4xl sm:text-5xl font-black mb-2">
                  {stat.number.value}
                </span>
                <span className="text-white/70 text-[10px] sm:text-[11px] font-black uppercase tracking-[0.2em]">
                  {stat.title.value}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}